export interface IManualTriggerInput {
    tripId: string;
    inDate: string;
    outDate?: string;
    checkpointIndex: number;
}
